const getApiHost = (env) => {
  switch (env) {
    case 'local':
      return loginapp.env.LOCAL_API_HOST;
    case 'test':
      return 'https://api.storytelbridge.com/auth-web-components-service';
    default:
      return 'https://api.storytel.net/auth-web-components-service';
  }
};

const getSthpHost = (env) => {
  const origin = location.origin;

  switch (env) {
    case 'local':
      return loginapp.env.LOCAL_STHP_HOST;
    case 'test':
      const testRegex =
        /https?:\/\/(test?(0[1-9]|10|-nightly)|localhost|next)\.storytel\.(com|dev)/g;
      return origin.match(testRegex) ? origin : 'https://test06.storytel.com';
    default:
      const prodRegex = /https:\/\/(((w{3}\.|staging(0[1-3])\.)storytel)|mofibo)\.com/g;
      return origin.match(prodRegex) ? origin : 'https://www.storytel.com';
  }
};

const getFirebaseConfig = (env, country) => {
  const testConfig = {
    apiKey: 'AIzaSyAQLlRb_IZxsFtNr6eKVSGI2XqGEMmvhGQ',
    // authDomain: 'storytel-accounts-test.firebaseapp.com',
    authDomain: window.location.host,
    databaseURL: 'https://storytel-accounts-test.firebaseio.com',
    projectId: 'storytel-accounts-test',
    storageBucket: 'storytel-accounts-test.appspot.com',
    messagingSenderId: '195597693343',
    appId: '1:195597693343:web:da0e19df936f9c413c8daa',
  };

  const prodConfig = {
    apiKey: 'AIzaSyAPsaBlt8o0uw_h1wdx9gleKfsILNdhuUI',
    authDomain: window.location.host,
    databaseURL: 'https://storytel-accounts-prod.firebaseio.com',
    projectId: 'storytel-accounts-prod',
    storageBucket: 'storytel-accounts-prod.appspot.com',
    messagingSenderId: '381837560703',
    appId: '1:381837560703:web:67feae41b4ee9ff7eaa84a',
  };

  switch (env) {
    case 'local':
      return testConfig;
    case 'test':
      return testConfig;
    default:
      return prodConfig;
  }
};

module.exports = { getApiHost, getSthpHost, getFirebaseConfig };
